// src/config.js
export const config = {
  production: {
    redirectUri: "https://coachai.csld.amazon.dev/",
    logoutUri: "https://coachai.csld.amazon.dev/",
    apiEndpoint: "bedrock", // Uses original working API with JWT auth
    apiUrl: "https://cm2yoapsi8.execute-api.us-east-1.amazonaws.com/bobbie",
    // OIDC configuration for Cognito + Amazon Federate + Midway
    auth: {
      authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_WqDymJ50t",
      client_id: "2elbk24054arsa4mg1ndlap9o7",
      redirect_uri: "https://coachai.csld.amazon.dev/",
      post_logout_redirect_uri: "https://coachai.csld.amazon.dev/",
      scope: "aws.cognito.signin.user.admin email openid profile",
      response_type: "code",
      automaticSilentRenew: true,
      loadUserInfo: true,
    },
  },
  test: {
    redirectUri: "https://test-environment.d12ztxlr9f4r1j.amplifyapp.com/",
    logoutUri: "https://test-environment.d12ztxlr9f4r1j.amplifyapp.com/",
    apiEndpoint: "bedrock", // Uses bedrock backend environment
    apiUrl: "https://api-test.coachai.csld.amazon.dev",
  },
  bedrockTest: {
    redirectUri: "https://bedrock-test.d12ztxlr9f4r1j.amplifyapp.com/",
    logoutUri: "https://bedrock-test.d12ztxlr9f4r1j.amplifyapp.com/",
    apiEndpoint: "bobbie", // Uses bobbie backend environment
    apiUrl: "https://api-bedrock.coachai.csld.amazon.dev",
  },
  // New Supernova domain deployment configuration - Replacing CloudFront
  supernova: {
    redirectUri: "https://coachai-b.csld.amazon.dev/",
    logoutUri: "https://coachai-b.csld.amazon.dev/",
    apiEndpoint: "bedrock", // Uses original working API with JWT auth
    apiUrl: "https://cm2yoapsi8.execute-api.us-east-1.amazonaws.com/bobbie",
    // OIDC configuration for Cognito + Amazon Federate + Midway
    auth: {
      authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_WqDymJ50t",
      client_id: "2elbk24054arsa4mg1ndlap9o7",
      redirect_uri: "https://coachai-b.csld.amazon.dev/",
      post_logout_redirect_uri: "https://coachai-b.csld.amazon.dev/",
      scope: "aws.cognito.signin.user.admin email openid profile",
      response_type: "code",
      automaticSilentRenew: true,
      loadUserInfo: true,
    },
  },
  development: {
    redirectUri: "http://localhost:4321/",
    logoutUri: "http://localhost:4321/",
    apiEndpoint: "local", // Uses local development API
    apiUrl: "http://localhost:3001", // Local API server for development
  },
};

export const isProduction = window.location.hostname === "coachai.csld.amazon.dev";
export const isTest = window.location.hostname === "test-environment.d12ztxlr9f4r1j.amplifyapp.com";
export const isBedrockTest = window.location.hostname === "bedrock-test.d12ztxlr9f4r1j.amplifyapp.com";
export const isSupernova = window.location.hostname === "coachai-b.csld.amazon.dev";
// Legacy CloudFront - no longer accessible after CloudFrontSigner offboarding
export const isCloudFront = window.location.hostname === "d3efdkdruxwi32.cloudfront.net";
export const currentConfig = isProduction
  ? config.production
  : isTest
  ? config.test
  : isBedrockTest
  ? config.bedrockTest
  : isSupernova
  ? config.supernova
  : isCloudFront
  ? config.production // Fallback to production if old CloudFront URL accessed
  : config.development;

// Local development mode detection
export const isLocalDevelopment = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
export const LOCAL_DEV_MODE = process.env.NODE_ENV === 'development' && isLocalDevelopment;
